var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav',{staticClass:"fixed-bottom py-0 d-flex justify-content-around mt-2",attrs:{"id":"nav-menu"}})])
}]

export { render, staticRenderFns }